<template>
  <el-container class="BomView">
    <el-main class="p-0 pb-default">
      <el-tabs ref="tabs" v-model="activeTab" type="card">
        <el-tab-pane label="등록" name="1">
          <el-form
            ref="form"
            label-width="70px"
            class="form-label-70"
            :model="failure"
            :rules="rules"
            inline
          >
            <div class="flex">
              <div>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="품목" prop="product_id">
                      <el-select
                        v-model="failure.product_id"
                        @change="handleChangeProductId"
                      >
                        <el-option
                          v-for="item in products"
                          :key="item.id"
                          :value="item.id"
                          :label="item.name"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="수량" prop="amount">
                      <ANumberInput v-model="failure.amount" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="단위">
                      <AProductUnitSelector
                        v-model="failure.unit_id"
                        :id="failure.product_id"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="규격" prop="size">
                      <el-input
                        v-model="failure.size"
                        class="readonly"
                        readonly
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="사유" prop="reason">
                      <el-input v-model="failure.reason" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-button
                      type="primary"
                      class="button"
                      @click="handleClickInsert"
                      >불량 등록</el-button
                    >
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="내역" name="2">
          <ATable ref="table" :data="items" hide-top-panel hide-button-insert>
            <el-table-column
              type="index"
              label="No"
              :width="$width.index"
              :index="handleIndex"
            />
            <el-table-column
              prop="product_name"
              label="품목"
              width="150"
              show-overflow-tooltip
            />
            <el-table-column prop="unit_name" label="단위" width="60" />
            <el-table-column prop="amount" label="수량" width="60" />
            <el-table-column prop="reason" label="사유" />
            <el-table-column
              label="등록일"
              prop="created_at"
              :width="$width.date"
              :formatter="util.dateFormat"
            />
            <el-table-column
              prop="created_user_name"
              label="등록자"
              :width="$width.username"
            />
          </ATable>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <el-footer>
      <el-button class="close-button" @click="handleCloseDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";

export default {
  name: "FailureForm",
  mixins: [form],
  data() {
    var checkAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("수량을 입력해 주세요."));
      }
      callback();
    };
    return {
      title: this.$t("lang.production"),
      activeTab: "1",
      product_id: null,
      amount: 0,
      items: [],
      selection: [],
      failure: {},
      rules: {
        product_id: [{ required: true, message: "품목을 선택해 주세요." }],
        amount: [
          { required: true, message: "수량을 등록해 주세요." },
          { validator: checkAmount },
        ],
        action: [{ required: true, message: "처리내용을 입력해 주세요." }],
      },
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  computed: {
    products() {
      let items = this.data.detail.material;
      return items.sort(this.util.sortByName);
    },
  },
  methods: {
    initFailure() {
      return {
        id: 0,
        production_id: this.data.id,
        product_id: null,
        product_name: null,
        size: null,
        desc: null,
        unit_id: null,
        amount: 0,
      };
    },
    loadData() {
      this.failure = this.initFailure();
      this.api.listFailureProduction(this.data).then((res) => {
        this.handleResponse(res);
        this.items = res.data;
      });
    },
    closeDialog() {
      this.$emit("completed");
    },
    doInsert() {
      this.api.createFailure(this.failure).then((res) => {
        this.handleResponse(res, "등록되었습니다.");
        if (res.error !== this.system.noError) {
          return;
        }
        this.loadData();
      });
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleChangeProductId(value) {
      let item = this.data.detail.material.find((p) => p.id === value);
      this.failure.product_name = item.name;
      this.failure.size = item.size;
      this.failure.unit_id = item.unit_id;
    },
    handleClickInsert() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.util.confirm(
          this,
          this.title,
          "불량 정보를  등록하시겠습니까?",
          this.doInsert
        );
      });
    },
    handleCloseDialog() {
      this.$emit("completed");
    },
    handleResponse(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      if (!message) {
        return;
      }
      this.util.notify_success(this, this.title, message);
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  width: 46%;
}
</style>
